import { render } from "./ChampionRunes.vue?vue&type=template&id=6c4266d1&scoped=true"
import script from "./ChampionRunes.vue?vue&type=script&lang=ts"
export * from "./ChampionRunes.vue?vue&type=script&lang=ts"

import "./ChampionRunes.vue?vue&type=style&index=0&id=6c4266d1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6c4266d1"

export default script